import { Account } from 'src/sync/account';
import { MatSnackBar } from '@angular/material/snack-bar';
import { View } from 'src/graphics/view';
import { Settings } from 'src/graphics/settings';
import { Store } from 'src/sync/store';

export class StatelessMessage {
    readonly event: string | undefined;

    constructor(public message: any, public origin: string, public addressee?: string) { };

    public json(): string {
        return JSON.stringify(this);
    }

    public static fromJson<T extends StatelessMessage>(this: new (...args: any[]) => T, json: string): T {
        const object = JSON.parse(json);

        return new this(object.message, object.origin, object.addressee);
    }
}

export class ForceViewSyncMessage extends StatelessMessage {
    override readonly event = 'force-view-sync';

    constructor(public override message: { position: { x: number, y: number }, scale: number; }, origin: string, addressee?: string) {
        super(message, origin, addressee);
    }
}

export class DropTokenMessage extends StatelessMessage {
    override readonly event = 'drop-token';

    constructor(public override message: { tokenId: string }, origin: string, addressee?: string) {
        super(message, origin, addressee);
    }
}

export class StatelessMessengerService {
    public constructor(private snackbar: MatSnackBar,) { }

    public onStateless(payload: StatelessMessage) {
        switch (payload.event) {
            case 'force-view-sync':
                this.forceViewSync(payload as ForceViewSyncMessage);
                break;
            case 'drop-token':
                this.dropToken(payload as DropTokenMessage);
                break;
        }
    }

    private forceViewSync(payload: ForceViewSyncMessage) {
        if (payload.origin == Account.id) return;
        const previousCenter = View.viewport.center;
        const previousScale = View.viewport.scale;

        View.apply(payload.message.position, payload.message.scale);

        const start = `${View.coerce(previousCenter.x)}, ${View.coerce(previousCenter.y)}`;
        const end = `${View.coerce(payload.message.position.x)}, ${View.coerce(payload.message.position.y)}`;

        const snackbarRef = this.snackbar.open(`Moved your view from (${start}) to (${end}).`, 'Go Back', { duration: 5000 });
        snackbarRef.onAction().subscribe(() => View.apply(previousCenter, previousScale));
    }

    private dropToken(payload: DropTokenMessage) {
        Store.activeSprite.next(undefined);
    }
}
